module.exports = "fragment CreditCardFragment on CreditCard {\n  id\n  brand\n  last4\n  expMonth\n  expYear\n  object\n}\n"